import { User, UserRole } from '../types';
import { parseJwtPayload } from './authLogin';

/**
 * معرف الوكيل لـ JoinAgentGroup — يطابق مجموعة الباكند (Agent.Id كنص).
 * المدير الثانوي: معرف الوكيل الأب من JWT أو الحقل agentId إن وُجد.
 */
export function resolveAgentGroupIdForDashboardHub(user: User | null): string | null {
  if (!user) return null;

  const relevantRoles = [
    UserRole.Agent,
    UserRole.SubAgent,
    UserRole.MainAgent,
  ];
  if (!relevantRoles.includes(user.role)) return null;

  let token: string | null = null;
  try {
    token = localStorage.getItem('token');
  } catch {
    token = null;
  }
  const payload = token ? parseJwtPayload(token) : null;
  const fromJwt =
    String(payload?.agent_id ?? payload?.AgentId ?? payload?.agentId ?? '').trim() || undefined;
  /** من /api/Agents/me — يجب أن يطابق <c>Agent.Id</c> (مجموعة SignalR)، وليس <c>sub</c> الذي هو User.Id */
  const fromProfile = user.agentId?.trim() || undefined;

  if (user.role === UserRole.Agent || user.role === UserRole.MainAgent) {
    return fromJwt || fromProfile || null;
  }
  if (user.role === UserRole.SubAgent) {
    /** لا نستخدم user.id — هو معرّف المستخدم وليس الوكيل الأب */
    return fromJwt || fromProfile || null;
  }

  return null;
}
